import React from "react";
import "./Telecom.css";

const TelecomFeatures = () => {
  return (
    <div className="telecom-container" id="Telecom">
        <h1 className="telecom-title">Telecom</h1>
      <div className="top-grid">
        {/* Box 1 */}
        <div className="feature-box">
          <h2>1. Network Performance Optimization</h2>
          <ul>
            <li className="tele-li"><strong>Real-Time Monitoring:</strong> Detects and resolves issues such as bandwidth congestion, network outages, or weak signal areas.</li>
            <li className="tele-li"><strong>Predictive Maintenance:</strong> Use data to forecast when and where maintenance will be required, minimizing unplanned downtime.</li>
            <li className="tele-li"><strong>Load Balancing:</strong> Ensure that traffic is evenly distributed across the network, maintaining high speeds for customers.</li>
          </ul>
          <p className="note">This leads to improved customer satisfaction, reduced service interruptions, and a more reliable network overall.</p>
        </div>

        {/* Box 2 */}
        <div className="feature-box">
          <h2>2. Customer Churn Prediction</h2>
          <ul>
            <li className="tele-li"><strong>Churn Alerts:</strong> Detect early warning signs of dissatisfaction and intervene with personalized offers or support.</li>
            <li className="tele-li"><strong>Loyalty Program Optimization:</strong> Tailor retention strategies and loyalty programs based on customer behavior data.</li>
            <li className="tele-li"><strong>Pricing Strategy:</strong> Predict the ideal price points to prevent churn driven by cost concerns.</li>
          </ul>
          <p className="note">By proactively addressing churn, telecom providers can keep their existing customer base while attracting new subscribers.</p>
        </div>
      </div>

      {/* Box 3 */}
      <div className="bottom-grid">
        <div className="feature-box">
          <h2>3. Data-Driven Revenue Growth Strategies</h2>
          <ul>
            <li className="tele-li"><strong>Segment Customers:</strong> Identify high-value customers and create personalized offerings to increase ARPU.</li>
            <li className="tele-li"><strong>New Service Rollouts:</strong> Predict the success of new offerings in various customer segments.</li>
            <li className="tele-li"><strong>Market Expansion:</strong> Use data insights to target potential markets or geographies.</li>
          </ul>
          <p className="note">With data-driven strategies, telecom companies can enhance their service offerings and maximize revenue opportunities.</p>
        </div>
      </div>
    </div>
  );
};

export default TelecomFeatures;
